import { useEffect, useState } from 'react';

type Rutina = {
  id: string;
  nombre: string;
  fecha: string;
};

type Progreso = {
  rutinaId: string;
  completada: boolean;
  fecha: string;
};

export default function ProgresoRutinas() {
  const [rutinas, setRutinas] = useState<Rutina[]>([]);
  const [progreso, setProgreso] = useState<Progreso[]>([]);
  const [error, setError] = useState('');

  const usuarioId = localStorage.getItem('id');

  useEffect(() => {
    if (!usuarioId) return;

    fetch(`http://localhost:5001/api/rutinas?usuarioId=${usuarioId}`)
      .then(res => res.json())
      .then(data => setRutinas(data))
      .catch(() => setError('❌ Error al cargar rutinas'));

    fetch(`http://localhost:5001/api/progreso?usuarioId=${usuarioId}`)
      .then(res => res.json())
      .then(data => setProgreso(data))
      .catch(() => setError('❌ Error al cargar progreso'));
  }, []);

  const marcarCompletada = async (rutinaId: string) => {
    try {
      await fetch(`http://localhost:5001/api/progreso`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ usuarioId, rutinaId, fecha: new Date().toISOString() })
      });

      setProgreso(prev => [...prev, { rutinaId, completada: true, fecha: new Date().toISOString() }]);
    } catch {
      alert('❌ Error al marcar rutina como completada');
    }
  };

  const rutinaCompletada = (id: string) =>
    progreso.some(p => p.rutinaId === id && p.completada);

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <h2 className="text-3xl font-bold text-center mb-6">📊 Progreso de Rutinas</h2>

      {error && <p className="text-red-600 text-center mb-4">{error}</p>}

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {rutinas.map((r) => (
          <div key={r.id} className={`bg-white shadow rounded-lg p-4 border-2 ${
            rutinaCompletada(r.id) ? 'border-green-500' : 'border-gray-300'
          }`}>
            <h3 className="text-xl font-semibold mb-1">{r.nombre}</h3>
            <p className="text-sm text-gray-700">
              <strong>Fecha asignada:</strong> {new Date(r.fecha).toLocaleDateString()}
            </p>

            {rutinaCompletada(r.id) ? (
              <p className="mt-3 text-green-600 font-semibold">✅ Completada</p>
            ) : (
              <button
                onClick={() => marcarCompletada(r.id)}
                className="mt-3 bg-blue-600 hover:bg-blue-700 text-white py-1 px-3 rounded"
              >
                Marcar como completada
              </button>
            )}
          </div>
        ))}
      </div>

      {rutinas.length === 0 && (
        <p className="mt-6 text-center text-gray-600">No tenés rutinas asignadas aún.</p>
      )}
    </div>
  );
}
